<template>
  <div :class="{'height-100': !terminal}" class="lista-comandas container-fluid">
    <loading v-if="load"/>
    <div :class="load ? 'invisible' : 'visible'">
      <div class="mx-auto" style="max-width: 800px">
        <div class="row mb-3">
          <div class="col-md-12 d-flex">
            <input id="refComanda" type="search" class="form-control mr-2" min="1" placeholder="Pesquisar comanda"
                   @keyup="pesquisarComanda()" @search="pesquisarComanda()" @keyup.enter="novaComanda(true)" v-model="ref_comanda">
            <button class="btn btn-primary text-nowrap" @click="novaComanda()" title="Nova comanda">
              <i class="fa fa-plus mr-1"></i><span class="d-none d-md-inline"> Nova comanda</span>
            </button>
            <button class="btn btn-outline-secondary ml-2" @click="buscarComandas()" title="Atualizar comandas" style="min-width: 56px">
              <i class="fa fa-sync-alt"></i><span class="d-none d-md-inline"> </span>
            </button>
          </div>
        </div>
      </div>
      <div class="text-center mt-2 mb-3">
        <i class="fa fa-circle text-success"></i> Disponível <span class="px-2">|</span> <i class="fa fa-circle text-secondary"></i> Ocupada
      </div>
      <div class="row no-gutters">
        <div class="col-4 col-md-2 p-1" v-for="c in comandas">
          <a :class="c.id_comanda ? 'btn-secondary' : 'btn-success'" class="btn btn-comanda text-left py-3 small" href="javascript:" @click="selecionarComanda(c)">
            <h5 class="mb-0 text-ellipsis font-weight-bold">{{c.numero}}</h5>
            <div class="text-ellipsis small" :title="c.observacao">{{c.observacao || c.mesa || 'Ocupada'}}</div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Loading from "../../../components/commons/Loading";
  export default {
    name: 'Comandas',
    components: {Loading},
    props: ['terminal'],
    data() {
      return {
        token: localStorage.getItem('key'),
        ref_comanda: '',
        load: false,
        comandas: [],
        searchComandas: [],
        pesquisa: {
          tipo: 3
        }
      }
    },

    methods: {
      buscarComandas(notLoad) {
        if (this.load) {
          return;
        }

        this.load = !notLoad;

        this.$http.get('comandas/mesas/' + this.token, {params: this.pesquisa})
          .then(response => {
            this.comandas = [];
            let comandas = response.data || [];

            for (let i=1; i <= this.qtd_comandas; i++) {
              let bd = comandas.find(c => parseInt(c.ref_comanda) === i);
              let numero = (i < 10 ? '0' : '') + i;

              if (bd) {
                this.comandas[i - 1] = { ...bd, numero, observacao: (bd.nome_cliente || bd.observacao), mesa: (bd.mesa ? `Mesa: ${bd.mesa}` : null) }
                comandas = comandas.filter(c => c !== bd);

              } else {
                this.comandas[i - 1] = { numero, observacao: 'Disponível' }
              }
            }

            if (comandas.length) {
              comandas.forEach(c => {
                this.comandas.push({ ...c, numero: c.ref_comanda, observacao: (c.nome_cliente || c.observacao), mesa: (c.mesa ? `Mesa: ${c.mesa}` : null) });
              });
            }

            this.searchComandas = this.comandas;
            this.load = false;
            this.$nextTick(() => {
              this.$helpers.focusElement('refComanda');
            });

          }, res => {
            console.log(res);
            this.comandas = [];
            this.load = false;
            this.$swal(res.data.msg || 'Erro temporário');
          });
      },

      pesquisarComanda() {
        if (this.ref_comanda.trim() && isNaN(this.ref_comanda)) {
          this.comandas = this.searchComandas.filter(c => c.observacao && c.observacao.toLowerCase().indexOf(this.ref_comanda.toLowerCase()) > -1);

        } else {
          this.comandas = this.searchComandas;
        }
      },

      novaComanda(enter) {
        if (enter && this.is_mobile) {
          return;
        }

        if (!this.ref_comanda.trim() || isNaN(this.ref_comanda)) {
          this.$swal("Por favor informe o número da sua comanda").then(() => {
            this.$helpers.focusElement('refComanda');
          });

          return;
        }

        let numero = parseInt(this.ref_comanda);
        this.ref_comanda = '';

        if (numero < 0 || numero > 10000000000000) {
          this.$swal('Por favor, informe um número de comanda válido').then(() => {
            this.$helpers.focusElement('refComanda');
          });

          return;
        }

        this.selecionarComanda(this.comandas.find(c => c.ref_comanda == numero) || { numero });
      },

      selecionarComanda(venda) {
        if (this.terminal) {
          this.$emit('selecionar', venda.id_comanda, venda.numero);
          return;
        }

        let url = !venda.id_comanda ? '/pdv/comanda/' + parseInt(venda.numero) : '/pdv/' + venda.id_comanda;

        if (this.$route.path !== url) {
          this.$router.push(url);

        } else if (venda.id_comanda) {
          this.$emit('atualizar');
        }

        this.$emit('openComanda');
      }
    },

    mounted() {
      this.buscarComandas();
    },

    computed: {
      qtd_comandas() {
        return parseInt(this.$store.state.pdv.qtd_comandas)
      }
    },

    sockets: {
      comanda_order(data) {
        if (data && data.tipo_comanda === '3') {
          this.buscarComandas(true);
        }
      }
    }
  }
</script>

<style scoped>
  .btn-comanda {
    display: block;
    height: 100%;
  }

  .lista-comandas.height-100 {
    height: calc(100vh - 136px);
    padding: 18px 15px;
  }

  @media (max-width: 767px) {
    .lista-comandas.height-100 {
      padding-bottom: 78px;
    }
  }
</style>
